import React, { Fragment, useState, useEffect, useRef } from 'react';
import {
  Wrapper,
  ScrollableWrapper,
  TabsList,
  TabListItem,
  TabButton,
  TabContent,
  TabsMarkersList,
  TabsMarkersListItem,
  TabMarker,
  TabMarkerActive,
  TabMarkerInactive
} from './styles';

interface Props {
  data: {
    title: string;
    image: any;
    tooltip: any;
  }[];
}

export default function Tabs({ data = [] }: Props) {
  const [activeTab, setActiveTab] = useState(0);
  const [transitioning, setTransitioning] = useState(false);
  const timeout = useRef<number>(0);

  function changeTab(index: number) {
    if (index !== activeTab) {
      setTransitioning(true);
      timeout.current = setTimeout(() => {
        setActiveTab(index);
        setTimeout(() => {
          setTransitioning(false);
        }, 0);
      }, 300);
    }
  }

  useEffect(() => {
    return () => {
      clearTimeout(timeout.current);
    };
  }, []);

  return (
    <Wrapper>
      <ScrollableWrapper>
        <TabsList>
          {data.map(({ title }, index) => (
            <TabListItem key={index}>
              <TabButton
                active={activeTab === index}
                onClick={() => changeTab(index)}
              >
                {title}
              </TabButton>
            </TabListItem>
          ))}
        </TabsList>
      </ScrollableWrapper>
      <TabContent isTransitioning={transitioning}>
        {data.map(({ title, image, tooltip }, index) => {
          if (activeTab !== index) {
            return null;
          }

          return (
            <Fragment key={index}>
              {image}
              {tooltip}
            </Fragment>
          );
        })}
      </TabContent>
      <TabsMarkersList>
        {data.map((_tab, index) => (
          <TabsMarkersListItem key={index}>
            <TabMarker
              active={activeTab === index}
              onClick={() => changeTab(index)}
            >
              {index + 1}
              <TabMarkerActive alt="" src={require('assets/active-tab.svg')} />
              <TabMarkerInactive
                alt=""
                src={require('assets/inactive-tab.svg')}
              />
            </TabMarker>
          </TabsMarkersListItem>
        ))}
      </TabsMarkersList>
    </Wrapper>
  );
}
